module.exports = __webpack_public_path__ + "static/media/QUOTE1.42150947.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Element/img/QUOTE1.png
// module id = 274
// module chunks = 0